import React from "react";
import { StyledList } from "./styled";

export default function List(props) {
    return (
        <StyledList margin={props.margin} width={props.width} {...props}>
            {props.children}
        </StyledList>
    )
}